import { Settings, ExitToApp, Person, ContactMail} from '@material-ui/icons';
import BillingForm from '../components/Settings/Forms/billingForm';
import GeneralForm from '../components/Settings/Forms/generalForm';
import PackagesForm from '../components/Settings/Forms/packageForm';
import PaymentMethodForm from '../components/Settings/Forms/paymentMethodForm';
import SecurityPolicyForm from '../components/Settings/Forms/securityPolicyForm';
import UpdatePasswordForm from '../components/Settings/Forms/updatePasswordForm';
import AiCreditsForm from '../components/Settings/Forms/aiCreditsForm';
import CancelForm from '../components/Settings/Forms/cancelForm';

const userProfileLinkOptions = [
    {
        title: 'Add a social profile',
        link:'/brands',
        icon: Person,
    },
    {
        title: 'Invite a team member',
        link:'/team',
        icon: ContactMail,
    },
]

const profileSettingsTabOptions = [
    {
        title: 'General',
        //form : General,
        form:GeneralForm,
        active:true,
        userRole: ["1","2"]
    },
    // {
    //     title: 'Update Password',
    //     // form:UpdatePasswordForm,
    //     form: ChangePassword,
    //     active:false,
    // },
    {
        title: 'Security & Policy',
        form:SecurityPolicyForm,
    //    form: SecurityPolicy,
        active:true,
        userRole: ["1","2"]
    },
    // {
    //     title: 'Billing',
    //     // form:BillingForm,
    //     form: Billing,
    //     active:false,
    // userRole: ["1","2"]
    // },
    {
        title: 'Packages',
        form:PackagesForm,
        active:true,
        userRole: ["1"]
    },
    {
        title: 'Payment Method',
        form:PaymentMethodForm,
        //form: UpdateCard,
        active:true,
        userRole: ["1"]
    },
    {
        title: 'AI Credits',
        form:AiCreditsForm,
        active:true,
        userRole: ["1"]
    },
    {
        title: 'Cancellation',
        form:CancelForm,
        active:true,
        userRole: ["1"]
    },
]

export { userProfileLinkOptions, profileSettingsTabOptions };
